export default "__VITE_ASSET__BcVAujK___"